import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "../../../../../reducers/initialState";
import { OFFER_PARTNER_UPDATED } from "features/offer/edit/client/form/eventTypes";

export default function questionnaireReducer(state = initialState.currentOffer.clientQuestionnaireData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_QUESTIONS_SUCCEEDED: {
      let key = action.key;
      const offerPartnerQuestions = {
        ...state.offerPartnerQuestions,
        [key]: {
          key,
          isLoaded: true
        }
      };

      return {
        ...state,
        offerPartnerQuestions
      };
    }

    case types.LOAD_OFFER_QUESTIONACTIONS_SUCCEEDED: {
      let key = action.key;
      const offerPartnerQuestionActions = {
        ...state.offerPartnerQuestionActions,
        [key]: {
          key,
          isLoaded: true
        }
      };

      return {
        ...state,
        offerPartnerQuestionActions
      };
    }

    case OFFER_PARTNER_UPDATED: {
      const { documentId, siteId, partnerId } = action.event.eventBody;
      let key = `${documentId}-${siteId}-${partnerId}`;
      const offerPartnerQuestions = {
        ...state.offerPartnerQuestions,
        [key]: {
          ...state.offerPartnerQuestions[key],
          key,
          isLoaded: false
        }
      };
      return {
        ...state,
        offerPartnerQuestions
      };
    }

    case eventTypes.PARTNER_QUESTIONS_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}-${action.event.eventBody.partnerId}`;
      const offerPartnerQuestions = {
        ...state.offerPartnerQuestions,
        [key]: {
          ...state.offerPartnerQuestions[key],
          key,
          isLoaded: false
        }
      };

      return {
        ...state,
        offerPartnerQuestions
      };
    }

    case eventTypes.PARTNER_QUESTIONACTIONS_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}-${action.event.eventBody.partnerId}`;
      const offerPartnerQuestionActions = {
        ...state.offerPartnerQuestionActions,
        [key]: {
          ...state.offerPartnerQuestionActions[key],
          key,
          isLoaded: false
        }
      };

      return {
        ...state,
        offerPartnerQuestionActions
      };
    }

    default:
      return state;
  }
}
